export const handleNullUndefined = (value: string | null | undefined) => {
  return value !== null && value !== undefined && value !== "" ? value : "''";
};
